import React from 'react';
import { QuickFilter } from '../../types';

import './styles.css';
import { currentSearchFilterInputNeeded } from '../../utils';
interface FilterBadgeProps {
  className?: string;
  filter: QuickFilter;
  onClick: (filter: QuickFilter) => void;
}
const FilterBadge = ({ className, filter, onClick }: FilterBadgeProps) => {
  return (
    <>
      <div
        className={`quick-filter-badge-container ${className}`}
        onClick={() => onClick(filter)}
      >
        {filter.label}
      </div>
      {currentSearchFilterInputNeeded(filter.type) && filter.value && (
        <div
          className={`quick-filter-badge-container ${className}`}
          onClick={() => onClick(filter)}
        >
          {filter.value}
        </div>
      )}
    </>
  );
};

export default FilterBadge;
